import { useEffect, useCallback, RefObject } from "react";

const isRefArray = (
    ref: RefObject<any> | RefObject<any>[]
): ref is RefObject<any>[] => {
    return "length" in ref;
};

const isTarget = (
    ref: RefObject<any>,
    event: MouseEvent,
    index: number
): boolean => {
    if (!ref || !ref.current) {
        return false;
    }

    if (Array.isArray(ref.current)) {
        const element = ref.current[index];
        return !!element && element.contains(event.target);
    }

    return ref.current.contains(event.target);
};

const trueForAny = (array: any[], condition: (props: any) => boolean) => {
    return array.reduce((conditionAlreadyMet, value) => {
        return conditionAlreadyMet || condition(value);
    }, false);
};

const useClickOutside = (
    ref: RefObject<any> | RefObject<any>[],
    onclick: () => void,
    index: number
) => {
    const handleClick = useCallback(
        (click: MouseEvent) => {
            if (isRefArray(ref)) {
                if (
                    trueForAny(ref, (ref: RefObject<any>) =>
                        isTarget(ref, click, index)
                    )
                ) {
                    return;
                }
            } else {
                if (isTarget(ref, click, index)) {
                    return;
                }
            }
            onclick();
        },
        [index, onclick, ref]
    );

    useEffect(() => {
        document.addEventListener("click", handleClick);

        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [handleClick]);

    return ref;
};

export default useClickOutside;
